import React, { FC, useMemo } from 'react';

import Typography from '@material-ui/core/Typography';
import { TFunction } from 'i18next';
import qs from 'qs';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import FullScreenBackgroundWrap from '../../components/UI/FullScreenBackgroudWrap';
import useStyles from './styles';

const updatedErrors = [
  {
    tKey: 'resetPasswordLinkUsed',
    titleTKey: 'linkExpired',
    originalValue: 'This URL can be used only once',
  },
  {
    tKey: 'resetPasswordLinkUsed',
    titleTKey: 'linkExpired',
    originalValue: 'Access expired.',
  },
];

const checkOnTextUpdates = (text: string | null | undefined, t: TFunction) => {
  if (text) {
    const match = updatedErrors.find((item) => item.originalValue === text);

    if (match) {
      return {
        title: t(`error.${match.titleTKey || 'authError'}`),
        description: t(`error.${match.tKey}`),
      };
    }
  }

  return {
    title: t('error.authError'),
    description: t('error.defaultAuthErrorDescription'),
  };
};

const AuthErrorPage: FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation();

  const errorMessages = useMemo(() => {
    return checkOnTextUpdates(qs.parse(location?.search?.slice(1))?.error_description, t);
  }, [location, t]);

  return (
    <FullScreenBackgroundWrap>
      <div className={classes.wrapper}>
        <Typography variant="h2" className={classes.title}>
          {errorMessages?.title}
        </Typography>
        <Typography className={classes.description}>{errorMessages?.description}</Typography>
      </div>
    </FullScreenBackgroundWrap>
  );
};

export default AuthErrorPage;
